export const scrollToTop = id => {
  const references = document.querySelector(id);
  references.scrollIntoView({
    behavior: "smooth",
  });
};
